import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useToast } from "./top/store/toasterStore";

function Toaster({ title, variant, message }) {
  const { setToaster } = useToast();
  const [toastDetail, setToastDetails] = useState();
  const [toast, setToast] = useState(false);

  useEffect(() => {
    setToastDetails({ title, variant, message });
  }, [title, variant, message]);

  useEffect(() => {
    if (toastDetail) {
      setToast(true);
      setTimeout(() => {
        setToaster(null, null, null);
      }, 2500);
    }
  }, [toastDetail]);
  return (
    title &&
    variant &&
    message && (
      <div
        style={{
          top: 7,
          left: "0%",
          zIndex: 2147483647,
        }}
        className="d-flex position-fixed w-100 justify-content-center"
      >
        <Card style={{ width: "28rem" }} className="p-0 h-100 shadow-lg">
          <div className={`w-100 p-3 rounded-top ${variant}-light`}>
            {title}
          </div>
          <Card.Body className="h-100">
            <p className="mb-0">{message}</p>
          </Card.Body>
        </Card>
      </div>
    )
  );
}

export default Toaster;
